import { render } from "./Switchout.vue?vue&type=template&id=7ce7ee0b"
import script from "./Switchout.vue?vue&type=script&lang=js"
export * from "./Switchout.vue?vue&type=script&lang=js"

import "./Switchout.vue?vue&type=style&index=0&id=7ce7ee0b&lang=css"

import exportComponent from "/Users/gigi/Library/ask_admin-deps/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__